import { Scene, Input, Geom, Display } from "phaser";
import {
    backStaticAnimation, leftStaticAnimation, lightstickAnimation, mapHandler, reposeAnimation,
    rightStaticAnimation, turnStaticAnimation, upStaticAnimation, walkAnimation
} from '../../phaser/create';
import { walkHandler, directionHandler, randomDirection, setLastMovement } from '../../phaser/update';
import FullScreen from "../../phaser/components/fullScreen";
import PauseButton from "../../phaser/components/pauseButton";
import LightstickCounter from "../../phaser/components/lightstickCounter";
import ButtonPressed from "../../phaser/components/buttonPressed";
import HelpButton from "../../phaser/components/helpButton";
import Joystick from "../../phaser/components/joystick";

let cursors;
let walls;
let instructionsHandler = 0;

let characterSelected;
let objNames = {};
let timeoutDoor = {};
let footsteps;
let speedEnemy = 100;
let hearts = 1;
let totalHearts = 1;
let redHeartsObject = [];
let blackHeartsObject = [];
let gameSettings;
let defaultSettings = 1;

const randomPointsEnemy = [
    { x: 93, y: 202 },
    { x: 448, y: 482 },
    { x: 813, y: 190 },
    { x: 463, y: 1070 },
    { x: 798, y: 1366 },
];

export default class Game1 extends Scene {

    constructor() {
        super({ key: "Game1" });
    }
    init(data) {
        characterSelected = data.characterSelected;
        this.hasLightstick = false;
        speedEnemy = 100;
        redHeartsObject = [];
        blackHeartsObject = [];
        hearts = 1;
        this.events.off('buttonNext-dialogModal');
        this.startAll = false;
        setLastMovement('down');
    }

    preload() {
        if (this.sys.game.device.os.desktop) {
            console.log("desktop")
            this.isMobile = false;
        }
        else {
            this.isMobile = true;

            console.log("mobile")
        }
        cursors = this.input.keyboard.createCursorKeys();

    }

    create() {

        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        this.pauseButton = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.P);
        this.dialogModal = this.plugins.get('dialogModal');

        gameSettings = localStorage.getItem('sound');
        if (gameSettings === null) {
            localStorage.setItem('sound', 1);
            gameSettings = defaultSettings;
        }

        this.events.on('pause', () => {
            if(this.joystickManager) {
                this.joystickManager.pause();
            }
            this.startAll = false;
            this.ppalSong.pause();
        });

        this.events.on(`resume`, (data, args) => {
            this.sound.mute = false;
            this.ppalSong.resume();
            if(args) {
                footsteps.stop();
                this.ppalSong.stop();
                this.scene.stop();
                if(args.goHome) {

                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }

                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Hallway`, { characterSelected: characterSelected, loadAgain: true });
                }

                if(args.goStart) {

                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }

                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Start`);
                }
            } else {
                if(!this.showingInstruction) {
                    this.startAll = true;
                }

                if(this.isMobile) {
                    if(this.joystickManager) {
                        this.joystickManager.show();
                    }
                }

                gameSettings = localStorage.getItem('sound');
                if (gameSettings === '0') {
                    if(this.ppalSong.isPlaying) {
                        this.ppalSong.stop()
                    }
                } else {
                    if(!this.ppalSong.isPlaying) {
                        this.ppalSong.play();
                    }
                }
            }
        });


        this.cameras.main.setBounds(0, 0, 893);
        this.physics.world.setBounds(0, 0, 893);

        this.ppalSong = this.sound.add(`chasemeSong`, { loop: true, volume: 0.2 });
        if (gameSettings === '1') {
            this.ppalSong.play();
        }

        const map = mapHandler(this, 'game1', true, 8, 8);

        footsteps = this.sound.add(`footsteps`, { loop: true, rate: 2, volume: 0.2 });

        this.playing = false;
        walls = map.walls;
        walls.setScale(3);
        map.ground.setScale(3);

        this.door = map.map.createLayer('Door', map.tileset, 0, 0);
        this.door.setCollisionByProperty({ collides: true });
        this.door.setScale(3);



        this.lightstick = map.map.createLayer('Lightstick', map.tileset, 0, 0);
        this.lightstick.setScale(3);

        this.object = map.map.createLayer('Objects', map.tileset, 0, 0);

        this.object.setCollisionByProperty({ collides: true });

        this.object.setScale(3);

        objNames[characterSelected] = this.physics.add.sprite(443, 2487, `${characterSelected}-game1`, 4);
        objNames[characterSelected].setScale(2.5);
        objNames[characterSelected].setImmovable();

        const itemRandom = randomPointsEnemy[Math.floor(Math.random() * randomPointsEnemy.length)];

        this.enemy = this.physics.add.sprite(itemRandom.x, itemRandom.y, `enemy-game1`);
        this.enemy.setImmovable();
        this.enemy.setScale(2.5);

        this.deadSprite = this.physics.add.sprite(1622, 2051, `humo-game1`).setScale(2.5).setVisible(false);
        this.anims.create({
            key: `deadSpriteAnimation`,
            frames: this.anims.generateFrameNumbers('humo-game1', { start: 0, end: 16 }),
            frameRate: 7,
            repeat: -1
        });



        walkAnimation(this, `${characterSelected}-game1`);
        reposeAnimation(this, `${characterSelected}-game1`);
        turnStaticAnimation(this, `${characterSelected}-game1`);
        upStaticAnimation(this, `${characterSelected}-game1`);
        leftStaticAnimation(this, `${characterSelected}-game1`);
        rightStaticAnimation(this, `${characterSelected}-game1`);
        backStaticAnimation(this, `${characterSelected}-game1`);
        lightstickAnimation(this, `${characterSelected}-game1`);

        walkAnimation(this, `enemy-game1`);
        reposeAnimation(this, `enemy-game1`);
        turnStaticAnimation(this, `enemy-game1`);
        upStaticAnimation(this, `enemy-game1`);
        leftStaticAnimation(this, `enemy-game1`);
        rightStaticAnimation(this, `enemy-game1`);
        backStaticAnimation(this, `enemy-game1`);


        this.physics.add.collider(objNames[characterSelected], walls);
        this.physics.add.collider(this.enemy, walls, () => {
            randomDirection(`enemy-game1`);
        }, null, this);
        this.physics.add.collider(this.enemy, this.object, () => {
            randomDirection(`enemy-game1`);
        }, null, this);

        this.physics.add.collider(this.enemy, objNames[characterSelected], () => {

            // if(this.joystickManager) {
            //     this.joystickManager.pause();
            //     // this.joystickManager = null;
            // }
            this.deadSprite.setPosition(objNames[characterSelected].x, objNames[characterSelected].y);
            this.deadSprite.visible = true;
            this.deadSprite.anims.play(`deadSpriteAnimation`, true);
            objNames[characterSelected].setVelocity(0)
            objNames[characterSelected].setTint(0x473334);
            this.startAll = false;
            this.enemy.active = false;
            this.enemy.visible = false;


            clearTimeout(this.timeoutColliderEnemy);
            this.timeoutColliderEnemy = setTimeout(() => {

                this.tweens.add({
                    targets: redHeartsObject[hearts - 1],
                    alpha: 0,
                    scaleX: 0,
                    scaleY: 0,
                    ease: 'Linear',
                    duration: 200
                });

                var heartsTimeline = this.tweens.createTimeline();

                heartsTimeline.add({
                    targets: blackHeartsObject[hearts - 1],
                    scaleX: 1.5,
                    scaleY: 1.5,
                    ease: 'Power1',
                    duration: 200
                });

                heartsTimeline.add({
                    targets: blackHeartsObject[hearts - 1],
                    scaleX: 3,
                    scaleY: 3,
                    ease: 'Power1',
                    duration: 200
                });
                heartsTimeline.play();
                hearts -= 1;

                if (hearts > 0) {
                    randomDirection(`enemy-game1`);
                    this.startAll = true;
                    this.enemy.active = true;
                    this.enemy.visible = true;
                } else {
                    this.enemy.destroy();
                }

                setTimeout(() => {
                    if (hearts <= 0) {

                        if(this.joystickManager) {
                            this.joystickManager.destroyTest();
                        }
                        
                        this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                            if (progress === 1) {
                                footsteps.stop();
                                this.ppalSong.stop();
                                this.scene.stop();
                                this.events.off('buttonNext-dialogModal');
                                this.scene.start(`GameOver`, { characterSelected: characterSelected, level: 1 });
                            }
                        });

                    }

                }, 1000);

            }, 500);

        }, null, this);

        this.physics.add.collider(objNames[characterSelected], this.object);
        this.physics.add.collider(this.enemy, this.object);
        this.physics.add.collider(objNames[characterSelected], this.door, () => {
            clearTimeout(timeoutDoor);
            timeoutDoor = setTimeout(() => {

                if (this.hasLightstick) {
                    let total = JSON.parse(localStorage.getItem('noL'));
                    if (total) {
                        if (!total.includes(1)) {
                            total.push(1);
                            localStorage.setItem('noL', JSON.stringify(total));

                        }
                    } else {
                        localStorage.setItem('noL', JSON.stringify([1]));
                    }

                    this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                        if (progress === 1) {
                            footsteps.stop();
                            this.ppalSong.stop();
                            this.scene.stop();
                            if(this.joystickManager) {
                                this.joystickManager.destroyTest();
                                this.joystickManager = null;
                            }
                            this.events.off('buttonNext-dialogModal');

                            this.scene.start(`Win`, { characterSelected: characterSelected, level: 1 });
                        }
                    });

                }
            }, 1000);
        }, null, this);


        this.time.addEvent({
            delay: 3000,
            callback: () => {
                randomDirection(`enemy-game1`);
            },
            loop: true
        })

        this.time.addEvent({
            delay: 10000,
            callback: () => {
                if (speedEnemy < 500) {
                    speedEnemy += 10;
                }
            },
            loop: true
        })

        this.cameras.main.startFollow(objNames[characterSelected], true);

        this.buttonFullscreen = new FullScreen(this);
        this.buttonPause = new PauseButton(this, characterSelected);
        this.buttonHelp = new HelpButton(this);


        window.addEventListener("blur", () => {
            this.buttonPause.pauseByEvent();
         });
     
        //  document.addEventListener('visibilitychange', () => {
        //      if (document.visibilityState !== 'visible') {
        //          this.buttonPause.pauseByEvent();
        //  } 
        //  });
         
        this.events.on('buttonNext-dialogModal', (data) => {
            instructionsHandler++;
            if(data.id === 'start-text') {
                if(instructionsHandler === 1) {
                    this.dialogModal.setText("I think I heard footsteps... \nAm I not alone here? Is someone chasing me? \nI can't let anyone catch me before I find all the lightsticks.".toUpperCase(), `${characterSelected}-hallway`, false, false)                    
                }

                if(instructionsHandler === 2) {
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    this.startAll = true;
                    this.showingInstruction = false;

                    if(this.isMobile) {
                        this.joystickManager = new Joystick(objNames[characterSelected], `${characterSelected}-game1`, 300);
                        this.joystickManager.createJoystick();
                        this.joystickManager.activate(this.hasLightstick);
                    }
                }

            }

            if(data.id === 'finish-text') {
                if(instructionsHandler === 1) {
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    this.startAll = true;
                    this.showingInstruction = false;

                }
            }
        })


        objNames[characterSelected].anims.play(`repose-${characterSelected}-game1`);
        this.dialogModal._createImageDialog(this, 'start-text');
        this.dialogModal.setText("Wait a minute! This is 'Chase Me'! \nI need to focus and find the lightsticks as soon as possible. \nI think I heard footsteps... Am I not alone here? Is someone chasing me? \nI can't let anyone catch me before I find my lightsticks.", `${characterSelected}-hallway`, false, false)
        this.showingInstruction = true;

        if (this.isMobile) {

            this.buttonAction = new ButtonPressed(this, 700, 500 - 51, `buttonAction`);
            this.buttonAction.setScale(2);
            this.add.existing(this.buttonAction);
        }

        let x = 0;
        let y = 16;
        for (let i = 0; i < totalHearts; i++) {
            if (i === 0) {
                x += 40;
            } else {
                x += 30;
            }
            blackHeartsObject.push(this.add.image(x, y, `heartBlack`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
            redHeartsObject.push(this.add.image(x, y, `heartRed`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
        }

        this.lightstickCounter = new LightstickCounter(this);

        this.helpLightstick = this.add.bitmapText(0, 20, 
            'pixelfont', "Interact: spacebar/action button".toUpperCase(), 10,1).setTint(0xffffff).setOrigin(1, 0).setScale(1).setVisible(false).setScrollFactor(0);

    }
    update() {

        this.screenCenterX = (this.cameras.main.worldView.x + this.cameras.main.width / 2) + 50;
        this.screenCenterY =  this.cameras.main.worldView.y;

        if(this.startAll) {

            if (!this.isMobile) {
                walkHandler(cursors, objNames[characterSelected], 300, `${characterSelected}-game1`, this.hasLightstick);
            } else {
                if(this.joystickManager) {
                    this.joystickManager.show();
                }
            }
    
            const tile = this.lightstick.getTileAtWorldXY(objNames[characterSelected].x, objNames[characterSelected].y);
            if (tile) {
                if (this.lightstick.visible) {
                    this.helpLightstick.setPosition(this.screenCenterX, this.screenCenterY + 15);
                    this.helpLightstick.visible = true;
    
                    if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {

                        this.startAll = false;
                        this.lightstick.visible = false;
    
                        this.hasLightstick = true;
                        if(this.isMobile) {
                            this.joystickManager.setLightStickValue(this.hasLightstick);
                        }
                        this.showingInstruction = true;
                        this.dialogModal._createImageDialog(this, 'finish-text');
                        this.dialogModal.setText("I found it!\nThe teddy bear had it all along. \nNow I need to get back to the door without getting caught.".toUpperCase(), `${characterSelected}-hallway`, false, false)
                        setTimeout(() => {
                            this.dialogLightstickVisible = true;
                        }, 1000);
                    }
                }
            } else {
                this.helpLightstick.visible = false;
            }
    
            if ((!this.isMobile && (cursors.left.isDown || cursors.right.isDown || cursors.up.isDown || cursors.down.isDown))) {
                if (this.playing !== true) {
                    if (gameSettings === '1') {
    
                        footsteps.play();
                        this.playing = true;
                    }
                }
    
            } else {
                this.playing = false;
                footsteps.stop();
            }
    
            if (this.enemy.active) {
                directionHandler(this.enemy, speedEnemy, `enemy-game1`);
            }
        } else {
            if(this.isMobile) {
                if(this.joystickManager) {
                    objNames[characterSelected].setVelocity(0, 0);
                    objNames[characterSelected].anims.play(`repose-${characterSelected}-game1`);
                    this.joystickManager.pause();
                }
            } 
        }
    }

    _handleCircleAnimation() {
        const maskShape = new Geom.Circle(
            this.sys.game.config.width / 2,
            this.sys.game.config.height / 2,
            this.sys.game.config.height / 2
        );

        this.add.graphics()
            .fillCircleShape(maskShape)
            .generateTexture('mask')

        this.mask = this.add.image(0, 0, 'mask')
            .setPosition(
                this.sys.game.config.width / 2,
                this.sys.game.config.height / 2,
            );

        this.cameras.main.setMask(
            new Display.Masks.BitmapMask(this, this.mask)
        );
    }

}